var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"inspection-page"},[_c('div',{ref:"madeForm",staticClass:"left-form"},[_c('avue-form',{ref:"avueFormRef",attrs:{"option":_vm.formOption},model:{value:(_vm.form),callback:function ($$v) {_vm.form=$$v},expression:"form"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }